<template>
  <div>
    <el-card style="margin: 30px;min-height: 1000px;width: 100%">
      <div style="width: 100%;display: flex">
        <div style="display: flex;width: 12%;">
          <el-tree :expand-on-click-node="false" style="margin-top: 20px;width: 100%"
                   :data="menuData" :props="defaultProps"
                   @node-click="handleNodeClick"></el-tree>
        </div>
        <div style="width: 3%;display: flex;justify-content: center">
          <div style="height: 960px;background-color: #f1f1f1;width: 2px;margin-top: 20px"></div>
        </div>
        <div style="width: 85%">
          <div style="margin-top: 20px;margin-left: 20px">
            <el-button v-if="btnList.includes('menu_add_top')" @click="addMenuBtn" size="small" type="success">新增顶级菜单</el-button>
            <el-button v-if="currentClickItem.parent_id===0&&btnList.includes('menu_edit_top')" @click="editMenuBtn" size="small" type="success">编辑顶级菜单
            </el-button>
            <el-button v-if="currentClickItem.parent_id===0&&btnList.includes('menu_add_child')" @click="addItemMenuBtn" size="small" type="success">新增子菜单
            </el-button>
            <el-table
                border
                :data="tableData"
                style="width: 96%;margin-top: 30px">
              <el-table-column
                  prop="page_name"
                  align="center"
                  header-align="center"
                  label="页面名称">
              </el-table-column>
              <el-table-column
                  prop="page_code"
                  align="center"
                  header-align="center"
                  label="页面编码">
              </el-table-column>
              <el-table-column
                  align="center"
                  header-align="center"
                  label="父节点ID">
                <template>
                  <div>{{ currentClickItem.id }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  header-align="center"
                  label="操作">
                <template slot-scope="scope">
                  <el-button v-if="btnList.includes('menu_edit_child')" @click="editBtn(scope.row)" type="success" size="mini">修改</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

      </div>
    </el-card>


    <a-modal
        :visible="dialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="400px"
        @cancel="dialogCancel"
        @ok="ruleFormSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="页面名称" prop="pageName">
          <el-input v-model="ruleForm.pageName" clearable placeholder="请输入页面名称" size="small"
                    style="width: 200px" type="text"></el-input>
        </el-form-item>
        <el-form-item label="页面编码" prop="pageCode">
          <el-input :disabled="dialogTitle === '编辑顶级菜单' || dialogTitle === '编辑子菜单'" clearable
                    v-model="ruleForm.pageCode" placeholder="请输入页面编码"
                    size="small"
                    style="width: 200px" type="text"></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      currentClickItem: {},//当前选中的节点
      menuData: [],
      defaultProps: {
        children: 'childMap',
        label: 'page_name'
      },
      tableData: [],
      dialogState: false,
      dialogTitle: '',
      ruleForm: {
        pageName: '',
        pageCode: '',
        parentId: 0
      },
      rules: {
        pageName: [{required: true, message: "请输入页面名称", trigger: "blur"}],
        pageCode: [{required: true, message: "请输入页面编码", trigger: "blur"}],
      },



      btnList:[]
    }
  },
  created() {
    this.getMenuList();
    //获取用户当前页面的按钮权限
    console.log(this.$store.state.buttonPermission,'权限',this.$store.state.menuPermission,'页面')
    if(this.$store.state.buttonPermission&&this.$store.state.buttonPermission.length){
      this.btnList = []
      this.$store.state.buttonPermission.forEach((item)=>{
        if (item.page_code === '/system/page'){
          this.btnList.push(item.action)
        }
      })
    }
  },
  methods: {
    getMenuList() {
      this.postAxios("/sysUser/selSysPage", {}).then(res => {
        if (res.success) {
          this.menuData = res.content;
        } else {
          this.menuData = []
        }
      });
    },
    addMenuBtn() {
      this.dialogTitle = '新增顶级菜单'
      this.ruleForm.pageCode = ''
      this.ruleForm.pageName = ''
      this.ruleForm.parentId = 0
      this.dialogState = true
    },
    editMenuBtn() {
      this.dialogTitle = '编辑顶级菜单'
      this.ruleForm.pageCode = this.currentClickItem.page_code
      this.ruleForm.pageName = this.currentClickItem.page_name
      this.ruleForm.parentId = this.currentClickItem.parent_id
      this.dialogState = true
    },
    addItemMenuBtn() {
      this.dialogTitle = '新增子菜单'
      this.ruleForm.pageCode = ''
      this.ruleForm.pageName = ''
      this.ruleForm.parentId = this.currentClickItem.id
      this.dialogState = true
    },
    editBtn(row) {
      console.log(row)
      this.dialogTitle = '编辑子菜单'
      this.ruleForm.pageCode = row.page_code
      this.ruleForm.pageName = row.page_name
      this.ruleForm.parentId = row.id
      this.dialogState = true
    },
    dialogCancel() {
      this.dialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    //新增页面表单提交
    ruleFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          switch (this.dialogTitle) {
            case "新增顶级菜单":
            case "新增子菜单":
              this.postAxios("/sysUser/addSysPage", this.ruleForm).then(res => {
                if (res.success) {
                  this.dialogState = false
                  this.$message.success('保存成功!')
                  this.getMenuList();
                  this.currentClickItem = {}
                  this.tableData = []
                }
              })
              break;
            case "编辑顶级菜单":
              this.postAxios("/sysUser/updSysPage", {
                id: this.currentClickItem.id,
                pageName: this.ruleForm.pageName,
                parentId: this.ruleForm.parentId
              }).then(res => {
                if (res.success) {
                  this.dialogState = false
                  this.$message.success('保存成功!')
                  this.getMenuList();
                  this.currentClickItem = {}
                }
              })
              break;
            case "编辑子菜单":
              this.postAxios("/sysUser/updSysPage", {
                id: this.ruleForm.parentId,
                pageName: this.ruleForm.pageName,
                parentId: this.currentClickItem.id
              }).then(res => {
                if (res.success) {
                  this.dialogState = false
                  this.$message.success('保存成功!')
                  this.getMenuList();
                  this.tableData = []
                  this.currentClickItem = {}
                }
              })
              break;
          }
        }
      });
    },
    //点击当前节点查看子列表
    handleNodeClick(data) {
      this.currentClickItem = data
      console.log(this.currentClickItem);
      if (this.currentClickItem.parent_id === 0) {
        this.postAxios("/sysUser/selSysPageChildAndPermission", {
          parameterMap: {
            sysPageId: this.currentClickItem.id
          }
        }).then(res => {
          if (res.success) {
            if (res.entity) {
              this.tableData = res.entity.childList;
            } else {
              this.tableData = []
            }
          } else {
            this.tableData = []
          }
        });
      } else {
        this.tableData = []
      }
    }
  }
}
</script>

<style scoped>

</style>